import { gql } from 'graphql-request'

export const activeExports = gql`
  query ActiveExportRequests {
    activeExportRequests {
      id
      userId
      status
      createdAt
      updatedAt
      url
      export
    }
  }
`
